<template>
  <div class="attribution-screen">
    <h1>How did you hear about AudioScribe?</h1>

    <form
      @submit.prevent="handleSubmit"
      class="login-form"
      :class="{ 'error-active': hasError }"
    >
      <div class="attribution-options">
        <div
          v-for="option in attributionOptions"
          :key="option.value"
          class="onboarding-option-card"
          :class="{ selected: preferences.attributionSource === option.value }"
          @click.prevent="selectAttribution(option.value)"
        >
          <div class="onboarding-radio-container">
            <span
              class="onboarding-radio-circle"
              :class="{
                checked: preferences.attributionSource === option.value,
              }"
            ></span>
            <span class="onboarding-radio-text">
              <span class="option-title">{{ option.title }}</span>
              <span v-if="option.description" class="option-description">{{
                option.description
              }}</span>
            </span>
          </div>
        </div>
      </div>

      <div v-if="hasError" class="onboarding-form-error">
        <span class="error-icon icon-exclamation-mark"></span>
        <span class="error-txt">{{ validationErrors.attributionSource }}</span>
      </div>

      <div class="onboarding-nav-buttons">
        <button
          type="button"
          class="btn btn-secondary"
          @click="$emit('prevStep')"
        >
          Back
        </button>
        <input
          type="submit"
          class="btn btn-primary"
          value="Next"
          :disabled="isSubmitting"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { useOnboardingStore } from "@/stores/onboarding-store";
import { mapStores } from "pinia";
import { analytics } from "@/services/analytics.service";

export default {
  name: "AttributionScreen",
  computed: {
    ...mapStores(useOnboardingStore),
    preferences() {
      return this.onboardingStore.preferences;
    },
    validationErrors() {
      return this.onboardingStore.validationErrors;
    },
    isSubmitting() {
      return this.onboardingStore.isSubmitting;
    },
    hasError() {
      return !!this.validationErrors.attributionSource;
    },
  },
  mounted() {
    // Track step 3 viewed
    analytics.onboardingStep3Viewed();
  },
  data() {
    return {
      attributionOptions: [
        {
          value: "SEARCH",
          title: "Search Engine",
          description: "Google, Bing, etc.",
        },
        {
          value: "REDDIT",
          title: "Reddit",
          description: "",
        },
        {
          value: "SOCIAL_MEDIA",
          title: "Social Media",
          description: "Twitter/X, Instagram, TikTok",
        },
        {
          value: "AI_ASSISTANT",
          title: "AI Assistant",
          description: "ChatGPT, Perplexity, Claude",
        },
        {
          value: "YOUTUBE",
          title: "YouTube",
          description: "",
        },
        {
          value: "PODCAST",
          title: "Podcast",
          description: "",
        },
        {
          value: "FRIEND",
          title: "Friend or Colleague",
          description: "",
        },
        {
          value: "OTHER",
          title: "Other",
          description: "",
        },
      ],
    };
  },
  methods: {
    selectAttribution(value) {
      this.preferences.attributionSource = value;

      // Track attribution selected
      analytics.onboardingAttributionSelected({ source: value });

      // Clear validation errors
      this.onboardingStore.validationErrors = {};
    },
    handleSubmit() {
      if (this.onboardingStore.validateCurrentStep()) {
        // Track step 3 completed
        analytics.onboardingStep3Completed({
          attribution_source: this.preferences.attributionSource,
        });

        this.$emit("nextStep");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.attribution-screen {
  @include onboarding-screen-title;
}

.attribution-options {
  @include onboarding-options-list;
}
</style>
